import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PresetAddElementActionsComponent } from 'src/app/components/dialog';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { Lang, OrganizationState, ReferenceParams, Res } from 'src/app/models';
import { AddinfoService, ApiOrganizationsService, DialogModalService, LanguageService, NotificationService, PermissionService, ValidatorsService } from 'src/app/services';
import { ApiMainSettingsService } from 'src/app/services/api-main-settings.service';
import { ApiPresetsService } from 'src/app/services/api-presets.service';
import { PresetValidator } from '../preset-create/preset-create.validators';

@Component({
  selector: 'app-preset-edit',
  templateUrl: './preset-edit.component.html',
  styleUrls: ['./preset-edit.component.css']
})
export class PresetEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributePresetTypes: any[] = [];
  attributeForPresets: any[] = [];
  attributesGroupValue: any[] = [];
  attributesElements: any[] = [];
  attributeName: Lang;
  attrType: any;
  conditional: boolean;
  organizations: OrganizationState[];
  organization: any;
  presetId: any;
  presetsData: any;
  attributes: any[] = [];
  attributeGroups: any[] = [];
  ffInputLang:any = {name:'', valid: false};
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    org_id: [null],
    name: [null],
    type: [null, this.validator.type],
    conditional: [null],
    deleted_attrs_presets_content_id: [null],
    selectors: this.fb.array([]),
    attrs_presets_content: this.fb.array([])
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiPresets: ApiPresetsService,
    private notification: NotificationService,
    private validator: PresetValidator,
    private validatorService: ValidatorsService,
    private dialogModal: DialogModalService,
    private addinfoService: AddinfoService,
    private apiOrganozations: ApiOrganizationsService,
    private currentRoute: ActivatedRoute,
    private apiSettings: ApiMainSettingsService,
    public permissionAccess: PermissionService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.attrType = this.addinfoService.attrType;
    this.presetId = this.currentRoute.snapshot.paramMap.get('id');

    if (this.permissionAccess.check('REFERENCES_ATTRS_PRESET_TYPES')) {
      this.getAttributesTypes();
      this.form.get('type').setValidators(this.validator.type);
      this.form.updateValueAndValidity();

    } else {
      this.form.get('type').setValidators(null);
      this.form.updateValueAndValidity();
    }

    this.getAttributeForPresets();

    if (this.permissionAccess.check('REFERENCES_ORGANIZATIONS')) {
      this.getOrganizations();

    }


    // this.subscriptions.add(
    //   this.form.get('conditional').valueChanges.subscribe(val => {

    //     this.conditional = val;
    //   })
    // );


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngDestroy() {
    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getAttributesTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_preset_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {


        if (response != null) {

          this.attributePresetTypes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributeForPresets(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes_for_presets',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRIBUTES_FOR_PRESETS: ", response);


        if (response != null) {

          this.attributeForPresets = response.result;
          this.onEdit();

        }
      })
    );
  }

  /**
   * 
   * @returns 
   */
  initConditionsFields(): any {

    return this.fb.group({
      attribute_id: [null],
      attribute_value: [null],
      attr_present_type_id: [null],
      attr_reference_id: [null],
      attribute_value_type: [null],
      value_query: [null]
    });
  }

  
  /**
   * 
   */
  addConditionalFields(): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.push(this.initConditionsFields());
  }

  /**
   * 
   * @param elementData 
   */
  addConditionalFieldWithData(elementData: any): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.push(this.setConditionalDataInField(elementData));
  }

  /**
   * 
   * @param elementData 
   * @returns 
   */
  setConditionalDataInField(elementData: any): any {

    return this.fb.group({
      attribute_id: elementData.attribute_id, // attribute_value принимает массив, поэтому при построении формы значение необходимо указать в '[]'
      attribute_value: [elementData.attribute_value],// необходима инициация полей, заполнение происходит в методе setDataInForm(){}
      attr_present_type_id: [null],
      attribute_value_type: [null],
      value_query: [null]
    });

  }

  /**
  * 
  * @param address Address
  */
  addAttributesElementsFieldWithData(elementData: any, index?:number): void {

    let control = this.form.controls.attrs_presets_content as UntypedFormArray;
    let duplicate = this.form.controls.attrs_presets_content.value.findIndex(val => val.id == elementData.id);

    if(index != null){

      control.removeAt(index);
    }

    if(duplicate > -1 && elementData.id != null){

      control.removeAt(duplicate);
      control.push(this.setDataInAttributesElementsField(elementData));

    }else{
      control.push(this.setDataInAttributesElementsField(elementData))
    }    
  }

  /**
   * 
   * @param address Address
   */
  setDataInAttributesElementsField(elementData: any): any {

    console.log("ELEMENT DATA: ", elementData);
    

    return this.fb.group({
      id: elementData.id,
      attr_group_order_num: elementData.attr_group_order_num,
      attr_order_num: elementData.attr_order_num,
      attr_present_type_id: elementData.attr_present_type_id,
      attr_reference_id: elementData.attr_reference_id,
      attr_value_mask: elementData.attr_value_mask,
      attr_value_mask_err_message: elementData.attr_value_mask_err_message,
      attribute_group_id: elementData.attribute_group_id,
      attribute_group_name: elementData.attribute_group_name,
      attribute_id: elementData.attribute_id,
      attribute_name: elementData.attribute_name,
      attribute_preset_value: elementData.attribute_preset_value,
      attribute_preset_value_type: elementData.attribute_preset_value_type,
      attribute_value_type: elementData.attribute_value_type,
      attribute_values_max_count: elementData.attribute_values_max_count,
      autocomplete_func: elementData.autocomplete_func,
      front_field_attrs: elementData.front_field_attrs,
      is_default: elementData.is_default,
      mandatory: elementData.mandatory,
      readonly: elementData.readonly,
      selectors: elementData.selectors,
      translation: elementData.translation,
      visible: elementData.visible,
    });
  }



  /**
   * 
   * @param event 
   * @param i 
   */
  setAttrValues(event, i) {

    console.log("SET ATTRS: ", event, i);

    if (event) {

      this.form.get(['selectors', i, 'attr_present_type_id']).setValue(event.attr_present_type_id);
      this.form.get(['selectors', i, 'attribute_value_type']).setValue(event.attribute_value_type);
      this.form.get(['selectors', i, 'value_query']).setValue(event.value_query);
    }
  }

  /**
  * 
  * @param value 
  */
  getOutPutValue(value: any, index: number) {

    let attrs: string[] = [];

    if (value) {

      value.forEach(element => {
        attrs.push(element.id);
      });
    }

    this.form.get(['selectors', index, 'attribute_value']).setValue(attrs);

  }

  /**
   * 
   */
  setDataInForm(data: any): any {

    console.log("DATA FROM EDIT REQUEST: ", data);


    let selectors = {
      attribute_id: '',
      attribute_value: ''
    };

    this.attributeName = data.name;
    this.form.controls.id.setValue(data.id);
    this.form.controls.org_id.setValue(data.org_id);
    this.form.controls.type.setValue(data.type);
    this.form.controls.conditional.setValue(data.conditional);

    if (data.selectors) {

      for (let key in data.selectors) {

        selectors.attribute_id = key;
        selectors.attribute_value = data.selectors[key];

        this.addConditionalFieldWithData(selectors);

        // Дожидаемся данных по атрибуту для отображения/получения данных для поля attrivute_value
        if (this.attributeForPresets) {

          let element = this.attributeForPresets.filter(val => val.id == key);

          for (let i = 0; i < this.attributeForPresets.length; i++) {
            this.setAttrValues(element[i], i);
          }

        }

      }
    }

    if (data.attrs_presets_content.length > 0) {

      this.attributesElements = [];

      data.attrs_presets_content.forEach((attrs, index) => {

        this.addAttributesElementsFieldWithData(attrs);
        this.attributesElements.push(attrs);

      })
    }
  }


  /**
 * 
 * @param fieldName string
 * @param value Lang
 */
  eventFnFF(fieldName: string, value: Lang): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value);
  }


  /**
   * 
   */
  checkCondtitional(event) {


    let control = this.form.controls.selectors as UntypedFormArray;

    event ? this.addConditionalFields() : control.clear();

  }



  /**
  * 
  */
  getOrganizations(): void {

    let data = {
      ref_name: 'organizations',
      filter: {}
    }

    this.subscriptions.add(
      this.apiOrganozations.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getOrganizations: ', response);

        if (response != null) {

          this.organizations = response.result;

          // if (this.organizations.length > 0) {

          //   let res = this.organizations.filter(val => val.is_default_org == true);

          //   if (res.length > 0) {

          //     this.organization = res[0];
          //     this.apiOrganozations.setDataCurrentOrganization(res[0]);
          //   }
          // }
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  addElement(attributesElement: any, index: number, action:string): void {

    let data = {
      element_id: index ? index : 0,
      element_data: attributesElement ? attributesElement : null,
      action: action
    }

    this.dialogModal.open(data, PresetAddElementActionsComponent, 'xl').then(
      (result) => {

        if (result) {

          if (attributesElement != null) {
            this.attributesElements.splice(index, 1, result.element_data);
            this.addAttributesElementsFieldWithData(result.element_data, index);

          } else {

            this.attributesElements.push(result.element_data);
            this.addAttributesElementsFieldWithData(result.element_data);
          }

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param i number
   */
  removePresetField(i: number): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.removeAt(i);
  }

  /**
   * 
   * @param i number
   */
  onDelete(i: number): void {

    if (this.attributesElements[i].id != null) {

      let arr = this.form.controls.deleted_attrs_presets_content_id.value ? this.form.controls.deleted_attrs_presets_content_id.value : [];

      arr.push(this.attributesElements[i].id);

      this.form.controls.deleted_attrs_presets_content_id.setValue([...arr]);

      let control = this.form.controls.attrs_presets_content as UntypedFormArray;
      control.removeAt(i);

    }

    this.attributesElements.splice(i, 1);
  }

  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiPresets.edit(this.presetId).subscribe((response: Res) => {
        console.log('[RESPONSE] PRESET_EDIT: ', response);

        if (response != null) {

          this.presetsData = { ...response.result };
          let control = this.form.controls.attrs_presets_content as UntypedFormArray;
          control.clear();
          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  onConfirm() {

    let message = 'Уверены ли вы что хотите применить новые настройки? На данный момент все новые настройки применятся ко всем товарам, с которыми связан данный пресет.';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onUpdate();
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   */
  onUpdate() {

    this.progressRef.start();

    let selectors = {};

    for (let s of this.form.controls.selectors.value) {
      selectors[s.attribute_id] = s.attribute_value;
    }

    let data = {
      id: this.form.controls.id.value,
      org_id: this.form.controls.org_id.value,
      deleted_attrs_presets_content_id: this.form.controls.deleted_attrs_presets_content_id.value,
      name: this.form.controls.name.value,
      type: this.form.controls.type.value,
      conditional: this.form.controls.conditional.value,
      selectors: selectors,
      attrs_presets_content: this.form.controls.attrs_presets_content.value
    }


    this.subscriptions.add(
      this.apiPresets.update(data).subscribe((response: Res) => {
  
        if (response != null) {

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  resetForm(): void {

    let selectors: any[] = this.form.get('selectors').value;
    let attributesElements: any[] = this.form.get('attrs_presets_content').value;

    for (let item of selectors) {

      this.removePresetField(0);
    }

    for (let item of attributesElements) {

      this.onDelete(0);
    }

    this.form.reset();
    this.attributeName = null;
  }

  backTo () {

      
      this.router.navigate(['settings']);

      setTimeout(()=> this.apiSettings.switchTab('attributes'),1000)
      

  }

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
